// @ts-strict-ignore
import * as React from "react";
import NextLink from "components/parts/NextLink";
import { BreadContainer } from "./styles";

interface BreadcrumbProps {
  separator?: React.ReactNode;
  children: any;
}

const Crumb = ({ href, children, position = 0, ...props }) => (
  <li
    css={`
      padding-right: 6px;
      padding-left: ${position === 0 ? 0 : 6}px;
    `}
    itemProp={"itemListElement"}
    itemScope
    itemType={"https://schema.org/ListItem"}
    {...props}
  >
    <NextLink href={href}>{<span itemProp="name">{children}</span>}</NextLink>
    <meta itemProp="position" content={`${position + 1}`} />
  </li>
);

const Bread = ({ separator = ">", children }: BreadcrumbProps) => (
  <nav aria-label={"breadcrumb"} role={"navigation"}>
    <BreadContainer itemscope itemtype="https://schema.org/BreadcrumbList">
      {React.Children.map(children, (child, index) => {
        const childrenLength = React.Children.toArray(children).length;
        return (
          <React.Fragment>
            {React.cloneElement(child, { ...child.props, position: index })}
            {index !== childrenLength - 1 && separator}
          </React.Fragment>
        );
      })}
    </BreadContainer>
  </nav>
);

Bread.Crumb = Crumb;
export default Bread;
